export const ruleOptions = [
    {
        step: 'bureau_fraud_occurrences',
        name: 'Consulta de fraudes em Bureau',
        description: 'Assinante possui ocorrências de fraudes encontrada em Bureau',
        type: 'boolean'
    },
    {
        step: 'liveness',
        name: 'Liveness',
        description: 'Assinante foi identificado como fraudador na etapa de liveness.',
        type: 'boolean'
    },
    {
        step: 'fraud_face_matches',
        name: 'Banco de fraudes',
        description: 'Assinante possui face encontrada no banco de fraudes.',
        type: 'boolean'
    },
    {
        step: 'brazil_geolocation',
        name: 'Assinatura fora do Brasil',
        description: 'Processo de assinatura não foi feita no Brasil.',
        type: 'boolean'
    },
    {
        step: 'device_key_blocklist',
        name: 'Lista de dispositivos bloqueados',
        description: 'Lista de dispositivos bloqueados.',
        type: 'boolean'
    },    
    {    
        step: 'same_ip_different_document_numbers',
        name: 'Mesmo IP, diferentes CPFs',
        description: 'Se existirem outros processos de assinaturas no mesmo IP para número de documentos diferentes nos últimos 30 dias.',
        type: 'boolean'
    },
    {
        step: 'facematch_document',
        name: 'Grau de similaridade com documento',
        description: 'Pontuação de checagem de simlaridade de face com documento - OCR.',
        type: 'numeric'
    },
    {
        step: 'face_validation',
        name: 'Score de validação de face',
        description: 'Pontuação de validação de face',
        type: 'numeric'
    },
    {
        step: 'liveness_flags',
        name: 'Liveness - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de liveness.',
        type: 'list_presence'
    },
    {
        step: 'ocr_flags',
        name: 'OCR - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de OCR.',
        type: 'list_presence'
    }
];

export const ocrFlags = [
    {
        value: 'found_illeterate_person_text',
        name: 'Pessoa analfabeta detectada pelo texto do documento'
    },
    {
        value: 'document_edges_issue',
        name: 'Parte do documento ocultada (rodapé, cabeçalho, bordas)'
    },
    {
        value: 'has_physical_damage',
        name: 'Documento apresenta danos físicos'
    },
    {
        value: 'has_textual_legibility_issues',
        name: 'Documento apresenta problemas de ilegilibilidade'
    },
    {
        value: 'document_tampering',
        name: 'Documento ou foto facial com traços de adulteração'
    },
    {
        value: 'screen_display_detected',
        name: 'Documento exibido em uma tela '
    },
    {
        value: 'found_anomalous_pdf_creator_or_producer',
        name: 'Criador ou produtor do PDF é incomum'
    },
    {
        value: 'creation_and_modification_date_mismatch',
        name: 'Data de criação e modificação do PDF são diferentes'
    }
]

export const livenessFlags = [
    {
        value: 'multiple_people',
        name: 'Múltiplas pessoas detectadas na sessão de liveness'
    }
]

export const mapRuleNameByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.name ?? 'Not mapped rule name'
}

export const mapFlagName = (flag) => {
    switch (flag) {
        case 'found_illeterate_person_text':
            return 'Pessoa analfabeta'
        case 'multiple_people':
            return 'Múltiplas pessoas'
        case 'document_edges_issue':
            return 'Parte do documento foi ocultada'
        case 'found_state_text':
            return 'Encontrou estado'
        case 'found_footer_text':
            return 'Encontrou rodapé'
        case 'found_header_text':
            return 'Encontrou cabeçalho'
        case 'all_edges_detected':
            return 'Possível ocultação de contorno'
        case 'found_side_text':
            return 'Encontrou texto lateral'
        case 'screen_display_detected':
            return 'Documento exibido em uma tela'
        case 'text_tampering_detected':
            return 'Adulteração de conteúdo'
        case 'face_tampering_detected':
            return 'Foto facial adulterada'
        case 'has_physical_damage':
            return 'Documento apresenta danos físicos'
        case 'has_textual_legibility_issues':
            return 'Problemas de legibilidade'
        case 'document_tampering':
            return 'Documento ou foto facial com traços de adulteração'
        case 'found_anomalous_pdf_creator_or_producer':
            return 'Criador ou produtor do PDF é incomum'
        case 'creation_and_modification_date_mismatch':
            return 'Data de criação e modificação do PDF são diferentes'
        default:
            return 'Indicador não mapeado'
    }
}

export const mapRuleDecisionByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.description ?? 'Not mapped rule description'
}


export const repprovementDecisions = [
    {
        value: 'reproved',
        name: 'Reprovar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    }
]

export const mapRuleDecisionName = (decision) => {
    let decisionFound = repprovementDecisions.find(rule => rule.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}




